/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ociNumber: NonNullable<unknown>, productName: NonNullable<unknown> }} Cargo_Edit_DescriptionInputs */

const en_cargo_edit_description = /** @type {(inputs: Cargo_Edit_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCI: ${i?.ociNumber} — Product: ${i?.productName}`)
};

const es_cargo_edit_description = /** @type {(inputs: Cargo_Edit_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCI: ${i?.ociNumber} — Producto: ${i?.productName}`)
};

/**
* | output |
* | --- |
* | "OCI: {ociNumber} — Product: {productName}" |
*
* @param {Cargo_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_edit_description = /** @type {((inputs: Cargo_Edit_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Edit_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_edit_description(inputs)
	return es_cargo_edit_description(inputs)
});